import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Include/Header";
import Sidebar from "../Include/Sidebar";
import Footer from "../Include/Footer";
import Loader from "../Include/Loader";
import { Pagination, Search } from "../Table";
import DropDown from "../../../Components/DropDown";
import moment from "moment";
import { Check, X } from "lucide-react";
import Swal from "sweetalert2";
import axios from "axios";
import { V_URL } from "../../../BaseUrl";
import { getVerifyIssueReq } from "../../../Store/Admin/VerifyIssueRequest/getVerifyIssueReq";
import {
  getIssueStatusLabel,
  getStatusLabel,
} from "../../Store/Prosafe/components/ProStatus/StatusFile";
import toast from "react-hot-toast";

const IssueReqList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);
  const [disable, setDisable] = useState(true);

  useEffect(() => {
    if (localStorage.getItem("VA_TOKEN") === null) {
      navigate("/admin/login");
    }
    if (disable === true) {
      dispatch(
        getVerifyIssueReq({
          payload: {
            tag_number: 13,
            filter: JSON.stringify({ date: {} }),
          },
        })
      );
      setDisable(false);
    }
  }, [disable, navigate]);

  const entity = useSelector((state) => state?.getVerifyIssueReq?.user?.data);

  const commentsData = useMemo(() => {
    let computedComments = entity;

    if (search) {
      computedComments = computedComments?.filter((issue) =>
        issue.voucher_no?.toLowerCase()?.includes(search?.toLowerCase())
      );
    }
    setTotalItems(computedComments?.length);
    return computedComments?.slice(
      (currentPage - 1) * limit,
      (currentPage - 1) * limit + limit
    );
  }, [currentPage, search, limit, entity]);

  const handleRefresh = () => {
    setDisable(true);
  };

  const handleIssueDownload = async (id) => {
    try {
      const res = await axios.post(
        `${V_URL}/admin/download-issue-slip/${id}`,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
          },
        }
      );

      if (res?.data?.success) {
        window.open(res?.data?.data?.pdfUrl);
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message || "Something went wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleApprove = async (id, voucherNo, status) => {
    if (status === 3) {
      // Rejection flow
      const { value: reason } = await Swal.fire({
        title: `Reject Issue - ${voucherNo}`,
        input: "textarea",
        inputLabel: "Reason for Rejection",
        inputPlaceholder: "Type the rejection reason...",
        inputAttributes: {
          "aria-label": "Type your rejection reason here",
        },
        showCancelButton: true,
        confirmButtonText: "Reject",
        confirmButtonColor: "#e74c3c",
        cancelButtonColor: "#6c757d",
      });

      if (!reason) {
        Swal.fire(
          "Cancelled",
          "Rejection was cancelled or no reason was provided.",
          "info"
        );
        return;
      }

      const payload = {
        id,
        // accrej_time: moment().format("HH:mm"),
        admin_email: localStorage.getItem("VA_EMAIL"),
        rej_reason: reason,
        status: 4,
      };

      try {
        const myurl = `${V_URL}/admin/pro-issue-approval`;
        await axios({
          method: "post",
          url: myurl,
          data: payload,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
          },
        });
        Swal.fire(
          "Rejected!",
          "Issue has been rejected.",
          "success"
        );
        setDisable(true);
      } catch (err) {
        console.error(err);
        Swal.fire("Error!", "Something went wrong while rejecting.", "error");
      }
    } else if (status === 2) {
      const result = await Swal.fire({
        title: `Approve Issue - ${voucherNo}`,
        text: "Are you sure you want to approve this request?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, Approve",
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#d33",
      });

      if (!result.isConfirmed) return;

      const payload = {
        id,
        admin_email: localStorage.getItem("VA_EMAIL"),
        rej_reason: "",
        status: 3,
      };

      try {
        const myurl = `${V_URL}/admin/pro-issue-approval`;
        await axios({
          method: "post",
          url: myurl,
          data: payload,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
          },
        });
        Swal.fire(
          "Approved!",
          "Issue has been approved.",
          "success"
        );
        setDisable(true);
      } catch (err) {
        console.error(err);
        Swal.fire("Error!", "Something went wrong while approving.", "error");
      }
    }
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin/dashboard">Dashboard </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right"></i>
                  </li>
                  <li className="breadcrumb-item active">Issue Request List</li>
                </ul>
              </div>
            </div>
          </div>

          {disable === false ? (
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table show-entire">
                  <div className="card-body">
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div className="doctor-table-blk">
                            <h3>Issue Request List</h3>
                            <div className="doctor-search-blk">
                              <div className="top-nav-search table-search-blk">
                                <form>
                                  <Search
                                    onSearch={(value) => {
                                      setSearch(value);
                                      setCurrentPage(1);
                                    }}
                                  />
                                  <button className="btn">
                                    <img
                                      src="/assets/img/icons/search-normal.svg"
                                      alt="search"
                                    />
                                  </button>
                                </form>
                              </div>
                              <div className="add-group">
                                <button
                                  type="button"
                                  onClick={handleRefresh}
                                  className="btn btn-primary doctor-refresh ms-2"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Refresh"
                                >
                                  <img
                                    src="/assets/img/icons/re-fresh.svg"
                                    alt="refresh-icon"
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                          <DropDown
                            limit={limit}
                            onLimitChange={(val) => setlimit(val)}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <table className="table border-0 custom-table comman-table  mb-0 datatable">
                        <thead>
                          <tr>
                            <th>Sr.</th>
                            <th>Issue Date</th>
                            <th>Issue No.</th>
                            <th>Total Qty</th>
                            <th>Item Count</th>
                            {/* <th>Party</th> */}
                            {/* <th>Project No</th> */}
                            <th>Project</th>
                            <th>Received By</th>
                            <th>Approved By</th>
                            <th>Transport</th>
                            <th>Status</th>
                            <th>Acc/Rej</th>
                            <th className="text-end">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {commentsData?.map((elem, i) => (
                            <tr key={elem?._id}>
                              <td>{(currentPage - 1) * limit + i + 1}</td>
                              <td>
                                {moment(elem?.receive_date).format(
                                  "YYYY-MM-DD"
                                )}
                              </td>
                              <td>{elem.voucher_no}</td>
                              <td>{elem?.total_qty || "-"}</td>
                              <td>{elem.item_count || 0}</td>
                              {/* <td>{elem.party_data?.name || "-"}</td> */}
                              {/* <td>{elem?.manual_pro_no || "-"}</td> */}
                              <td>{`${elem.project_data?.name} ${elem.project_data?.project_no
                                ? `(${elem.project_data?.project_no})`
                                : ""
                                }` || "-"}</td>
                              <td>{elem?.issue_by?.name}</td>
                              <td>{elem.issueVerifyBy?.name || "-"}</td>
                              <td>{elem?.transport_data?.name || "-"}</td>
                              <td>{getStatusLabel(elem?.status)}</td>
                              <td className="d-flex gap-2">
                                {elem.status === 1 ? (
                                  <>
                                    <span
                                      className="present-table attent-status"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleApprove(
                                          elem._id,
                                          elem?.voucher_no,
                                          2
                                        )
                                      }
                                    >
                                      <Check />
                                    </span>
                                    <span
                                      className="absent-table attent-status"
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        handleApprove(
                                          elem._id,
                                          elem?.voucher_no,
                                          3
                                        )
                                      }
                                    >
                                      <X />
                                    </span>
                                  </>
                                ) : (
                                  <X />
                                )}
                              </td>
                              <td className="text-end">
                                <div
                                  className="dropdown dropdown-action"
                                  style={{ cursor: "pointer" }}
                                >
                                  <a
                                    className="action-icon dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="fa fa-ellipsis-v"></i>
                                  </a>
                                  <div className="dropdown-menu dropdown-menu-end">
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() =>
                                        navigate("/admin/view-issue-request", {
                                          state: elem,
                                        })
                                      }
                                    >
                                      <i className="fa-solid fa-eye m-r-5"></i>
                                      View
                                    </button>
                                    <button
                                      type="button"
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleIssueDownload(elem?._id)
                                      }
                                    >
                                      <i className="fa-solid fa-download m-r-5"></i>
                                      Download Issue Slip
                                    </button>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))}

                          {commentsData?.length === 0 ? (
                            <tr>
                              <td colspan="999">
                                <div className="no-table-data">
                                  No Data Found!
                                </div>
                              </td>
                            </tr>
                          ) : null}
                        </tbody>
                      </table>
                    </div>
                    <div className="row align-center mt-3 mb-2">
                      <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                        <div
                          className="dataTables_info"
                          id="DataTables_Table_0_info"
                          role="status"
                          aria-live="polite"
                        >
                          Showing {Math.min(limit, totalItems)} from{" "}
                          {totalItems} data
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                        <div
                          className="dataTables_paginate paging_simple_numbers"
                          id="DataTables_Table_0_paginate"
                        >
                          <Pagination
                            total={totalItems}
                            itemsPerPage={limit}
                            currentPage={currentPage}
                            onPageChange={(page) => setCurrentPage(page)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Loader />
          )}
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default IssueReqList;
